@let param = parameter();
@if (param.uidEntityType; as entityType) {
  <app-entity-auto-complete
    [id]="inputId()"
    [entityType]="entityType"
    [isArray]="param.kind === 'list'"
    [reopenOnClick]="true"
    [escapeClosesListOnly]="true"
    [value]="value() ?? null"
    (valueChange)="onReference($event)" />
} @else if (param.closed) {
  <app-select
    [id]="inputId()"
    [items]="closedItems()"
    [multiple]="param.kind === 'list'"
    [searchable]="closedItems().length > 8"
    [value]="closedValue()"
    (valueChange)="onClosed($event)" />
} @else {
  @switch (param.kind) {
    @case ('date') {
      <input
        class="form-input rounded-xs font-mono"
        type="date"
        [id]="inputId()"
        [value]="text()"
        (input)="valueChange.emit($any($event.target).value)" />
    }
    @case ('date-time') {
      <input
        class="form-input rounded-xs font-mono"
        type="datetime-local"
        [id]="inputId()"
        [value]="localDateTime()"
        (input)="onDateTime($any($event.target).value)" />
    }
    @case ('duration') {
      <app-duration-input
        [value]="text() || null"
        [ariaLabel]="label()"
        (valueChange)="valueChange.emit($event ?? '')" />
    }
    @case ('list') {
      <input
        class="form-input rounded-xs font-mono"
        type="text"
        autocomplete="off"
        [id]="inputId()"
        [value]="listText()"
        [placeholder]="'features.data.path_filter.value.list_hint' | translate"
        (input)="onList($any($event.target).value)" />
    }
    @default {
      <input
        class="form-input rounded-xs font-mono"
        type="text"
        autocomplete="off"
        [id]="inputId()"
        [value]="text()"
        (input)="valueChange.emit($any($event.target).value)" />
    }
  }
}
